export const TASK_PROFILE_SET = 'TASK_PROFILE_SET';
export const TASK_PROFILE_VIDEOS_SET = 'TASK_PROFILE_VIDEOS_SET';
export const TASK_PROFILE_IS_LOADING = 'TASK_PROFILE_IS_LOADING';
export const TASK_PROFILE_ERROR = 'TASK_PROFILE_ERROR';
export const TASK_PROFILE_RESET = 'TASK_PROFILE_RESET';
export const TASK_PROFILE_VIDEO_CREATED = 'TASK_PROFILE_VIDEO_CREATED';
export const TASK_PROFILE_VIDEO_REMOVED = 'TASK_PROFILE_VIDEO_REMOVED';
export const TASK_PROFILE_REMOVED = 'TASK_PROFILE_REMOVED';
